module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-card', {
    attrs: {
      "header": "设置规则名称",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "发货类型"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.saleTypeChange
    },
    model: {
      value: (_vm.form.sale_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "sale_type", $$v)
      },
      expression: "form.sale_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0",
      "value": "0"
    }
  }, [_vm._v("按天数")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1",
      "value": "1"
    }
  }, [_vm._v("按日期")])], 1)], 1), _vm._v(" "), (_vm.form.sale_type == 0) ? _c('el-form-item', {
    staticClass: "content-left",
    attrs: {
      "label": "预计几天后开始发货",
      "prop": "shipdays",
      "rules": [{
        required: true,
        message: '请输入商品预计发货时间',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商品预计几天后开始发货",
      "oninput": "value=value.replace(/[^\\d]/g, '')"
    },
    model: {
      value: (_vm.form.shipdays),
      callback: function($$v) {
        _vm.$set(_vm.form, "shipdays", $$v)
      },
      expression: "form.shipdays"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.sale_type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "预计发货时间",
      "prop": "sale_time",
      "rules": [{
        required: true,
        message: '请输入商品预计发货时间',
        trigger: 'blur'
      }]
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.form.sale_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "sale_time", $$v)
      },
      expression: "form.sale_time"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (!this.$route.params.id) ? _c('el-card', {
    attrs: {
      "header": "选择预售商品",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-00106963", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00106963"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/goodspresale/add.vue
// module id = 2417
// module chunks = 0